import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        },
        {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '浙江甚湖科技官网'
          }
        },
        {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '产品中心'
          },
        },
        {
          path: '/software/big',
          name: 'softwaree',
          component: resolve => require(['@/view/Software_bigData'], resolve),
          meta: {
            title: '产品中心 | Special Conn SSD'
          },
        },
        {
          path: '/software/smart',
          name: 'softwarea',
          component: resolve => require(['@/view/Software_smartTown'], resolve),
          meta: {
            title: '产品中心 | U.2 NVME'
          },
        },
        {
          path: '/SATA',
          name: 'SATA',
          component: resolve => require(['@/view/SATA'], resolve),
          meta: {
            title: '产品中心 | 2.5 SATA'
          },
        },
        {
          path: '/M2SATA',
          name: 'M2SATA',
          component: resolve => require(['@/view/M2SATA'], resolve),
          meta: {
            title: '产品中心 | M.2 SATA'
          },
        },
        {
          path: '/M2PCIE',
          name: 'M2PCIE',
          component: resolve => require(['@/view/M2PCIE'], resolve),
          meta: {
            title: '产品中心 | M.2 PCIE'
          },
        },
        {
          path: '/mSATA',
          name: 'mSATA',
          component: resolve => require(['@/view/mSATA'], resolve),
          meta: {
            title: '产品中心 | m SATA'
          },
        },
        {
          path: '/SD',
          name: 'SD',
          component: resolve => require(['@/view/SD'], resolve),
          meta: {
            title: '产品中心 | SD'
          },
        },
        {
          path: '/YD',
          name: 'YD',
          component: resolve => require(['@/view/YD'], resolve),
          meta: {
            title: '产品中心 | YD'
          },
        },
        {
          path: '/WBBGA',
          name: 'WBBGA',
          component: resolve => require(['@/view/WBBGA'], resolve),
          meta: {
            title: '产品中心 | WBBGA'
          },
        },
        {
          path: '/eMMC',
          name: 'eMMC',
          component: resolve => require(['@/view/eMMC'], resolve),
          meta: {
            title: '产品中心 | eMMC'
          },
        },
        {
          path: '/UFS',
          name: 'UFS',
          component: resolve => require(['@/view/UFS'], resolve),
          meta: {
            title: '产品中心 | UFS'
          },
        },
        {
          path: '/NandFlash',
          name: 'NandFlash',
          component: resolve => require(['@/view/Nand'], resolve),
          meta: {
            title: '产品中心 | Nand Flash'
          },
        },
        {
          path: '/UDP',
          name: 'UDP',
          component: resolve => require(['@/view/UDP'], resolve),
          meta: {
            title: '产品中心 | U盘'
          },
        },
        {
          path: '/Micro',
          name: 'Micro',
          component: resolve => require(['@/view/Micro'], resolve),
          meta: {
            title: '产品中心 | Micro'
          },
        },
        {
          path: '/FCBGA',
          name: 'FCBGA',
          component: resolve => require(['@/view/FCBGA'], resolve),
          meta: {
            title: '产品中心 | FCBGA'
          },
        },
        {
          path: '/FCCSP',
          name: 'FCCSP',
          component: resolve => require(['@/view/FCCSP'], resolve),
          meta: {
            title: '产品中心 | FCCSP'
          },
        },
        {
          path: '/2D',
          name: '2D',
          component: resolve => require(['@/view/2D'], resolve),
          meta: {
            title: '产品中心 | 2.5D'
          },
        },
        {
          path: '/3D',
          name: '3D',
          component: resolve => require(['@/view/3D'], resolve),
          meta: {
            title: '产品中心 | 3D'
          },
        },
        {
          path: '/SIP',
          name: 'SIP',
          component: resolve => require(['@/view/SIP'], resolve),
          meta: {
            title: 'SIP 先进封装'
          },
        },
        {
          path: '/PIANO',
          name: 'PIANO',
          component: resolve => require(['@/view/Pian'], resolve),
          meta: {
            title: '解决方案'
          },
        },
        {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '社会责任'
          }
        },
        {
          path: '/product/Solution/PC',
          name: 'PC',
          component: resolve => require(['@/view/product/Solution/PC'], resolve),
          meta: {
            title: 'PC应用'
          }
        },
        {
          path: '/product/Solution/Datacenter',
          name: 'Datacenter',
          component: resolve => require(['@/view/product/Solution/Datacenter'], resolve),
          meta: {
            title: '数据中心应用'
          }
        },
        {
          path: '/product/Solution/Terminal',
          name: 'Terminal',
          component: resolve => require(['@/view/product/Solution/Terminal'], resolve),
          meta: {
            title: '智能终端应用'
          }
        },
        {
          path: '/product/Solution/CAR',
          name: 'CAR',
          component: resolve => require(['@/view/product/Solution/CAR'], resolve),
          meta: {
            title: '智能汽车应用'
          }
        },
        {
          path: '/product/Solution/Mobile',
          name: 'Mobile',
          component: resolve => require(['@/view/product/Solution/Mobile'], resolve),
          meta: {
            title: '移动储存应用'
          }
        },
        {
          path: '/product/Solution/Industry',
          name: 'Industry',
          component: resolve => require(['@/view/product/Solution/Industry'], resolve),
          meta: {
            title: '行业终端应用'
          }
        },
        {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        },
        {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        },
        {
          path: '/core',
          name: 'core',
          component: resolve => require(['@/view/core'], resolve),
          meta: {
            title: '核心优势'
          }
        },
        {
          path: '/Classic',
          name: 'Classic',
          component: resolve => require(['@/view/Classic'], resolve),
          meta: {
            title: '经典案例'
          }
        },
        {
          path: '/news',
          name: 'news',
          component: resolve => require(['@/view/news'], resolve),
          meta: {
            title: '新闻动态'
          }
        },
        {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '人才计划'
          }
        },
        {
          path: '/soft',
          name: 'soft',
          component: resolve => require(['@/view/soft'], resolve),
          meta: {
            title: '存储部件'
          }
        },
        {
          path: '/GENRE',
          name: 'GENRE',
          component: resolve => require(['@/view/GENRE'], resolve),
          meta: {
            title: '先进封装'
          }
        },
        {
          path: '/store',
          name: 'store',
          component: resolve => require(['@/view/store'], resolve),
          meta: {
            title: '2D/3D'
          }
        },
        {
          path: '/WBB',
          name: 'WBB',
          component: resolve => require(['@/view/WBB'], resolve),
          meta: {
            title: 'WBBGA系列封装'
          }
        },
        {
          path: '/DD',
          name: 'DD',
          component: resolve => require(['@/view/DD'], resolve),
          meta: {
            title: '2.5D/3D晶圆级封装'
          }
        },
        {
          path: '/SIPALL',
          name: 'SIPALL',
          component: resolve => require(['@/view/zui'], resolve),
          meta: {
            title: 'SIP | 全部产品'
          }
        },
        {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/newwh',
          name: 'newwh',
          component: resolve => require(['@/view/NEWS/NEW1'], resolve),
          meta: {
            title: '新闻'
          }
        },
        {
          path: '/newzz',
          name: 'newzz',
          component: resolve => require(['@/view/NEWS/NEW2'], resolve),
          meta: {
            title: '新闻'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'], resolve),
          meta: {
            title: '相关服务'
          }
        },
        {
          path: '/SolidState',
          name: 'SolidState',
          component: resolve => require(['@/view/NewViews/SolidState/index'], resolve),
          meta: {
            title: '固态硬盘'
          }
        },
        {
          path: '/Consumer',
          name: 'Consumer',
          component: resolve => require(['@/view/NewViews/SolidState/ConsumerView'], resolve),
          meta: {
            title: '固态硬盘|消费级SSD'
          }
        },
        {
          path: '/SATAZ',
          name: 'SATAZ',
          component: resolve => require(['@/view/NewViews/SolidState/SATA'], resolve),
          meta: {
            title: '固态硬盘|消费级SSD|SATA'
          }
        },
        {
          path: '/PCIe',
          name: 'PCIe',
          component: resolve => require(['@/view/NewViews/SolidState/PCIe'], resolve),
          meta: {
            title: '固态硬盘|消费级SSD|PCIe'
          }
        },
        {
          path: '/Enterprise',
          name: 'Enterprise',
          component: resolve => require(['@/view/NewViews/SolidState/EnterpriseView'], resolve),
          meta: {
            title: '固态硬盘|企业级SSD'
          }
        },
        {
          path: '/EnterpriseSSD',
          name: 'EnterpriseSSD',
          component: resolve => require(['@/view/NewViews/SolidState/EnterpriseSSD'], resolve),
          meta: {
            title: '固态硬盘|企业级SSD|产品'
          }
        },
        {
          path: '/Industrial',
          name: 'Industrial',
          component: resolve => require(['@/view/NewViews/SolidState/IndustrialView'], resolve),
          meta: {
            title: '固态硬盘|工业控制级SSD'
          }
        },
        {
          path: '/DataCentersView',
          name: 'DataCentersView',
          component: resolve => require(['@/view/NewViews/SolidState/DataCentersView'], resolve),
          meta: {
            title: '固态硬盘|数据中心级SSD'
          }
        },
        {
          path: '/EmbeddedView',
          name: 'EmbeddedView',
          component: resolve => require(['@/view/NewViews/SolidState/EmbeddedView'], resolve),
          meta: {
            title: '固态硬盘|数据中心级SSD'
          }
        },
        {
          path: '/ThrrFive',
          name: 'ThrrFive',
          component: resolve => require(['@/view/NewViews/SolidState/ThrrFive'], resolve),
          meta: {
            title: '固态硬盘|数据中心级SSD|SSDS-3195'
          }
        },
        {
          path: '/Frontloaded',
          name: 'Frontloaded',
          component: resolve => require(['@/view/NewViews/SolidState/Frontloaded'], resolve),
          meta: {
            title: '前置存储'
          }
        },
        {
          path: '/ConsumerGrade',
          name: 'ConsumerGrade',
          component: resolve => require(['@/view/NewViews/SolidState/ConsumerGrade'], resolve),
          meta: {
            title: '前置存储|消费级存储卡'
          }
        },
        {
          path: '/MemorySticks',
          name: 'MemorySticks',
          component: resolve => require(['@/view/NewViews/SolidState/MemorySticks'], resolve),
          meta: {
            title: '前置存储|内存条'
          }
        },
        {
          path: '/ConsumerElectronics',
          name: 'ConsumerElectronics',
          component: resolve => require(['@/view/NewViews/ConsumerElectronics/index'], resolve),
          meta: {
            title: '消费电子'
          }
        },
        {
          path: '/SmartPSSD',
          name: 'SmartPSSD',
          component: resolve => require(['@/view/NewViews/ConsumerElectronics/SmartPSSD'], resolve),
          meta: {
            title: '消费电子'
          }
        },
        {
          path: '/GtuPan',
          name: 'GtuPan',
          component: resolve => require(['@/view/NewViews/ConsumerElectronics/GtuPan'], resolve),
          meta: {
            title: '消费电子|固态U盘'
          }
        },
        {
          path: '/AllFallsh',
          name: 'AllFallsh',
          component: resolve => require(['@/view/NewViews/AllFallsh/index'], resolve),
          meta: {
            title: '企业级主机'
          }
        },
        {
          path: '/FallshView',
          name: 'FallshView',
          component: resolve => require(['@/view/NewViews/AllFallsh/FallshView'], resolve),
          meta: {
            title: '企业级主机|全闪NAS'
          }
        },
        {
          path: '/SpeekTable',
          name: 'SpeekTable',
          component: resolve => require(['@/view/NewViews/AllFallsh/SpeekTable'], resolve),
          meta: {
            title: '企业级主机|DeepSeek机架式服务器'
          }
        },
        {
          path: '/news6',
          name: 'news6',
          component: resolve => require(['@/view/News/news6.vue'], resolve),
          meta: {
            title: '新闻'
          }
        },
        {
          path: '/news7',
          name: 'news7',
          component: resolve => require(['@/view/News/news7.vue'], resolve),
          meta: {
            title: '新闻'
          }
        },
        {
          path: '/news8',
          name: 'news8',
          component: resolve => require(['@/view/News/news8.vue'], resolve),
          meta: {
            title: '新闻'
          }
        },
        {
          path: '/news9',
          name: 'news9',
          component: resolve => require(['@/view/News/news9.vue'], resolve),
          meta: {
            title: '新闻'
          }
        },
        {
          path: '/newsdetail/:id',
          name: 'NewsDetailNew',
          component: resolve => require(['@/view/NEWS/NewsDetailNew'], resolve),
          meta: {
            title: '新闻'
          }
        },
      ]
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js